import { Button } from '@/components/ui/button';
import { useAuthClient } from '@/lib/authClient';
import { useDeviceConnection } from '@/hooks/use-device-connection';

export default function WaitingApprovalPage() {
  const { signOut } = useAuthClient();
  const { isRecoverySetUp, isChecking } = useDeviceConnection({
    refreshInterval: 3_000,
  });

  // Poll until status is loaded
  if (isChecking) return null;

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-white">
      <div className="w-full max-w-md text-center space-y-4">
        {/* Handle recovery passphrase set up. If not complete, show the setup instructions */}
        {!isRecoverySetUp ? (
          <>
            <h1 className="text-xl">Finish setting up your mobile app</h1>
            <p className="text-slate-600">
              Please enable biometrics and complete the recovery passphrase
              setup on your mobile device.
            </p>
          </>
        ) : (
          <>
            <h1 className="text-xl">You're done!</h1>
            <p className="text-slate-600">
              Please wait for an administrator to approve your signup.
            </p>
          </>
        )}
        <div className="pt-2">
          <Button
            variant="link"
            className="text-white bg-black"
            onClick={() => signOut()}
          >
            Click to sign out
          </Button>
        </div>
      </div>
    </div>
  );
}
